module.exports = __webpack_public_path__ + "img/new_gth.1625281e.png";